import { queryOptions } from '@tanstack/react-query'

import { fetchAppContent } from '../dal/contentful-app-dal'
import { queryKeys } from './query-keys'

export const appQueryOptions = (locale: string) =>
  queryOptions({
    queryKey: queryKeys.app.all(locale),
    queryFn: () => fetchAppContent(locale),
    staleTime: 5 * 60 * 1000,
  })
